import { useMemo } from 'react';
import { useAuthStore } from '../../store/authStore';
import { useEscolaComunicados } from '../../api/hooks/useEscolaComunicados';
import { useEscolaMidias } from '../../api/hooks/useEscolaMidias';
import { TvSignagePlayerCore } from '../../components/comunicados/TvSignagePlayerCore';
import type { ComunicadoItem } from '../../components/comunicados/ComunicadosConfig';

export default function TvGradeEscola() {
  const { escolaId, user } = useAuthStore();
  const { data: comunicados = [], isLoading: l1 } = useEscolaComunicados();
  const { midias = [], isLoading: l2 } = useEscolaMidias();

  const config = useMemo(
    () => ({
      scope: 'ESCOLA' as const,
      scopeId: escolaId || '',
      branding: {
        tenantName: (user as any)?.escolaNome || 'Escola Municipal',
        tenantBadge: 'Painel Digital da Escola',
        logoUrl: (user as any)?.escolaLogoUrl,
        primaryColor: '#2563eb',
        secondaryColor: '#1d4ed8',
        slogan: 'Educação para o Futuro',
        autoridadeNome: user?.nome,
        autoridadeCargo: 'Direção Escolar',
      },
    }),
    [escolaId, user]
  );

  return (
    <TvSignagePlayerCore
      config={config}
      comunicados={comunicados as unknown as ComunicadoItem[]}
      midias={midias}
      isLoading={l1 || l2}
    />
  );
}
